<ng-container *ngFor="let item of listInput; let i=index; trackBy:trackById;">
  <mat-form-field [ngClass]="classInputParse" id="'sequence-input-'+i">
    <mat-label>{{text['placeholder'] + ' ' + (i + 1)}}</mat-label>
    <input matInput 
      [type]="text['type']"
      [id]="'text-sq-'+i"
      autocomplete="off"
      (blur)="updateControl($event.target.value, i)" 
      required>
    <mat-icon matSuffix 
    (click)="deleteControl(i)" class="icon-off" [id]="'off-'+1" *ngIf="listInput.length !== 1"
    class="icon-control-off"matTooltip="Eliminar">
      highlight_off
    </mat-icon>
    <mat-icon matSuffix [id]="'add-'+i" (click)="addControl()" *ngIf="i === (listInput.length-1) && i !== max"
      class="icon-control-add" matTooltip="Agregar">
      add_circle_outline
    </mat-icon>
    <mat-hint>
      <mat-error *ngIf="!item">
        <span>Campo requerido </span>
      </mat-error>
    </mat-hint>
  </mat-form-field>
</ng-container>